var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNyk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGOS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#9EA2A2;}\n\t.st2{fill:#1D428A;}\n\t.st3{fill:#F58426;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.8,461.9l-33.7-43.7c-42.8-14.1-72.6-52.8-75.4-97.9l-20.9-27.1c-19.9,8.6-39.7,22.1-39.7,22.1 l-62.6-62.9l26.4-57.9L1.6,133.3h75.1l14.5-31.7l37.2-15l4.1-11.2l30.1,13.8l7.2-25l4.9-1.6c23.8-7.9,51.3-12.2,79.4-12.4 c0.8,0,9.7,0.1,10,0.1c1,0,5.4,0.2,5.4,0.2c23.8,1.1,46.1,5.1,66.4,11.8l5,1.6l6.6,23.9l10.9-8.2l60.9,21.7l14.7,32.1h75.5 l-47.7,61.6l26,57l-63.6,65.5c0,0-23.3-17-39.3-23.3l-19.2,24.7c-2.2,46.1-33.6,86.6-77.7,100.1L254.8,461.9L254.8,461.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "254.8,431.6 471.9,151.8 39.3,151.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.4,143L254.8,446L489.8,143L21.4,143z M471.9,151.8l-217,279.8L39.3,151.8L471.9,151.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440.5,171.3l-0.1-0.2l-0.2-0.1l-13.9-9.3l5.2-9.9l0.2-0.3l-0.1-0.3l-19.1-41.9l-0.1-0.3l-0.3-0.1l-51.5-18.3 l-0.4-0.1l-0.3,0.2l-13.7,10.4l-0.1,0.1l-0.1,0.2l-2.3,5.7c0,0-21.4-5.4-52.7-8.5c-3.2-0.3-11.7-1-25.4-2.1l-1.3-0.1l-1.4-0.1 l-0.3,0l-0.2,0.2l-10.2,10.1l0-10.4c0,0-28.9,1.6-47.8,4.2c-18.9,2.6-37.5,7.3-37.5,7.3l-3.4-7.3l-0.1-0.2l-0.2-0.1l-24.3-11.1 l-0.7-0.3l-0.3,0.7L135,97l-0.6-1.5l-0.3-0.6l-0.6,0.3l-34.8,14l-0.3,0.1l-0.1,0.3l-64.2,141l52.7,52.8l2.5-1.4 c1.6-0.9,3.8-2.2,6.4-3.7c6.4-3.8,15.1-8.9,19.3-10.9l0.8-0.4c5.4-2.6,8.1-3.9,33.7-14.9l2.1-0.8c0,0,2.9-1.1,8.2-2.9 c14.1-4.7,50.6-15.5,86-15.5h0.4c1.4,0,2.8,0,4.2,0.1c24,0.7,52.2,5.8,71.5,9.9c18.6,4,32.6,7.9,36.6,9l2.7,0.8 c17.6,6.8,39.2,18,59.1,30.8l2.5,1.6l53.3-54.9L440.5,171.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M434.8,176.2l-51.3-34.2l-8.9-25l15.9,5.6l6.4,15.6l24.1,7.7L407,114.8l-45.5-16.2l-8.4,6.5l15.1,49.2 l48.7,34.4l12.5,31.1l-20.3-9.1l-7-19.4l-24.9-7.3l13.3,43.8c4.1,1.5,8.2,3.1,12.2,4.7c11.1,4.5,21.9,9.4,32.5,14.9 c7.3,3.8,14.6,7.7,21.7,11.9l10.6-10.9L434.8,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.1,199.4l17.1-15.3l4.1,4.8l-16.9,48.5c9.2-4.1,18.6-7.8,28.1-11.2l12.2-40l-10.5-17.4L145,148l12.8-42.5 l-15.7-7.1L128,138.5L105.4,158l20.6-52l-22.1,8.8l-61,133.8l9.5,9.6c5.7-3.3,11.4-6.5,17.2-9.5L89.1,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243.7,103.9l-18.7,1l-8.8,100.4c7.9-0.8,16-1.3,24-1.5L243.7,103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.2,184.5l-21.7-1.3l-3.5-61.5l18.4,0.9l-2.2-16.9l-24.7-1.8l-11.1,11.1l0,76.9l11.6,11.9 c12,0.4,23.9,1.3,35.6,2.7L299.2,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.1,143.5l7.8,38.2l-5.1,28.9c7.6-1.5,15.2-2.7,23-3.7l0,0L214,106.2l-17.4,2.5l-5.7,33l-6.5-31 l-20.4,5.1l-28.4,105.7c8.2-2.6,16.5-4.9,24.9-6.9L176.1,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M327.1,178.9l6.1-8.3l8.9,7.4l8.2,37.4c8.6,2.2,17.1,4.6,25.6,7.3l-15.3-54.9l-15.8-12.9l9-12l-7.5-27.9 l-19.1-4.2l7.5,28.1l-11.9,15.9l-8.8-46.2l-17.7-2.2c0,0,8.9,67.7,13,101c8,1.1,15.9,2.5,23.8,4.1L327.1,178.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.9,224.4c0,0,7.4-4.3,22.1-5.9l-0.5-11.6c-8.1,0.3-16.1,0.8-24.1,1.5 C217.2,212.9,218.2,219.6,218.9,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.7,217.7c6,0.7,12.4,2.7,18,4.2c5.1,1.2,10.6,3.4,15.1,5.4l2.5-17.9c-11.8-1.5-23-2.3-35.1-2.7 C266,210.3,266,215.1,265.7,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.3,246c6.9-5.1,11-10.3,18.2-14.7c-1.4-6.5-3.2-14.9-4.5-21.3c-7.9,1-15.6,2.3-23.3,3.8 C181.5,223.4,185.3,236.3,188.3,246z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.8,231c6.7,3.9,11.9,8.2,17.9,14.1l1.2,0.9l9.4-31.2c-8.1-1.7-16-3.1-24.3-4.3L304.8,231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.5,258l22.5,5.3l18.9-37.4c-8.7-2.8-17.1-5.2-26-7.4L334.5,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.9,263.3c5.9-2.2,14-5.1,21.7-7.2L161,217.6c-8.8,2.1-16.5,4.4-25.1,7.1 C141.3,237.6,147.4,250.9,153.9,263.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120,277.2c1.3-1.1,14-6.6,22.8-10.3c-6.6-12-14.6-25.2-21.3-37.4c-9.5,3.4-18.2,6.9-27.4,11L120,277.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.2,294.1c4.1-2.4,8.4-4.9,13.1-7.7l-29.8-35.1c-5.7,2.9-11.3,6-16.8,9.2L88.2,294.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.9,268c17.9,6.9,42.9,21,52.8,27.6c4.6-4.4,29.5-30.5,32.9-34.1c-20.7-12.1-42.4-22.5-65-30.8 L368.9,268z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "262.3,217.1 253.8,216.8 253.6,196.1 262.5,205.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.7,213c-55.5,0-100.5,45-100.5,100.5c0,55.5,45,100.5,100.5,100.5c55.5,0,100.5-45,100.5-100.5 C356.2,258,311.2,213,255.7,213z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M261.9,220.5c-7.7,2.7-15.1,6.6-22.5,10c-5-3-7.9-3.8-11.3-6C238.7,220.8,250.1,220.2,261.9,220.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.9,263.2c-23.7-23.9-59.2-22.1-89.3-30.6c0,0,17.7-8.4,26.9-10.8C296.1,226.1,319.9,240.8,333.9,263.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.8,266.8c-22.7,34.9-25.8,77.9-7.7,115.6c-23.4-19.7-37.4-57.7-26.9-94.7 C174.8,275.6,185.9,265,200.8,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.1,291.6c12.3,36.5,15,76.8,46.7,113.5c-24.7,5-49.3-2.4-68.8-14.8c-24.2-35.3-21.9-88.1,2.3-122.3 C217.1,271.5,223.5,286.9,225.1,291.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M208.1,264.2c3.7-5.2,7.8-10.1,12.5-14.7c51.5,14.5,100.6,67.9,109,120.4c-2.5,4-8.3,9.5-12.3,13.4 c-12.8,11.5-26.9,17.5-40.4,20.7c-24-24.9-32-57.3-40.4-89.2c-6.5-24.5-11-43-28.3-50.5L208.1,264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.4,264c-24.9-21.9-59.5-19.1-88.6-29.4c-5.6,3.4-11.1,7.5-15.8,11.7c51.5,16.1,98.2,66.5,109.3,118.5 c8.1-11.7,12.9-25.2,14.9-39.6C349.5,303.2,349.3,283.1,328.4,264z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.4,247.9c-5,4.8-8.7,9.5-12.6,15l-0.1,0c-13.6-3.1-24.4,4-33,12.8c4.1-10.4,12.8-22.7,21.9-30.8 C201,245.2,207.1,245.1,216.4,247.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M220,244.7c4.9-4.3,9.6-8.1,15.4-11.6l-13.2-6.5c-8.8,3.6-18.2,8.3-24.7,14.2 C207.6,241.9,211.9,242.5,220,244.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.5,89.8l-4.1,4l-7,0.4l-2.6-2.3l-3.3,2.8l-7.6,0.7l-3.3-3.2l4.4-29.7l5.7-0.8l-3.1,26.2l4.1-0.5l3.2-26.3 l5.7-0.5l-2.4,26.1l4-0.4l2.1-26c2.4-0.3,3.7-0.2,5.8-0.4L241.5,89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.1,59.8l0.1,18.7l3.7,0l-0.2-18.6c0,0,3.8,0.1,5.6,0.3l0.7,21l-3.5,3.5l-1.2,0.1l0.2,9l-6.2-0.2l-0.1-9 l-1.2-0.1l-3.8-3.9l0.2-20.8C256.3,59.7,260.1,59.8,260.1,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.9,63.3l-1,6.1l-6.9,1.3l-1.3,7.2c2.5-0.5,4.1-0.7,7.1-1.1c-0.4,2.7-0.5,3.6-1,6.1l-7,1l-1.3,6.9l7.1-1 c0,0-0.7,4.6-1.1,6.7c-5,0.6-10,1.3-14.8,2.2c0,0,5.4-24.9,6.7-32.6L213.9,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.7,99.7l-7.2,1.4l3.3-13.6l-2.2-4.9l-5.7,19.5l-7.1,1.6c2.9-10.6,6-21.2,8.9-31.7c2.4-0.8,4.2-1.4,6.4-2 c0.8,1.8,2.7,5.4,2.7,5.4l1.7-6.6c0,0,4.5-1.2,6.7-1.7L187.7,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.5,65.6c0.7,8.5,2.1,16.7,3,24.6l-3.2,4.8l-10.2-0.7l-3.7-4c-0.7-8.7-1.1-17.4-1.6-26.1 c0.9-1.2,2.4-2.2,3.5-3.4l8.5,0.8L289.5,65.6z M279.9,67l1.8,20.3l3.6,0.3l-1.9-20.2L279.9,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M322.5,68.6c1.3,4.9,3.8,14.9,3.8,14.9l2.4,0.5l1.2-1.6l-3-12.5c0,0,3,0.8,6.2,1.8l3.2,12.1l-1.5,2.2l2.8,3.1 l4.2,14.7l-7-1.6l-2.7-10.3l-4.4-1l2.4,10.3l-7.1-1.4c-2.5-11.1-7-32.9-7-32.9S319.7,67.7,322.5,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311.5,69.8l2.3,12.1l-1.4,1.9l2.4,2.8l2.1,12.1l-6.8-1.2l-1.9-10l-4.1-0.5l1.4,9.8l-6.8-0.9l-4.5-33.3 l13,2.3L311.5,69.8z M301.6,70.2l1.2,8.5l3.8,0.4l-1.6-8.3L301.6,70.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNyk);
export default __webpack_public_path__ + "static/media/NYK.b471192fe9bded86f0142f8a58bfe228.svg";
export { ForwardRef as ReactComponent };